<template>
    <button @click="toggleMuted()"
            :class="{
                'pp-ui-button': applyStyles,
                'pp-ui-button-muted': applyStyles && muted,
                'pp-ui-button-unmuted': applyStyles && !muted,
             }"
    >
        <slot>
            <Muted v-if="muted"/>
            <Unmuted v-else/>
        </slot>
    </button>
</template>

<script>
  import {PPComponentMixin, PPPlayerMethodsMixin} from "../mixins";
  import Muted from '../style/assets/muted.svg';
  import Unmuted from '../style/assets/unmuted.svg';

  export default {
    name: "PPButtonToggleMuted",
    components: {Muted, Unmuted},
    mixins: [PPComponentMixin, PPPlayerMethodsMixin],
    computed: {
      muted () {
        if (this.player.ad.active) {
          return this.player.ad.muted;
        }
        return this.player.muted;
      }
    }
  }
</script>
